import { render, staticRenderFns } from "./examModel.vue?vue&type=template&id=6d7c0824&scoped=true"
import script from "./examModel.vue?vue&type=script&lang=js"
export * from "./examModel.vue?vue&type=script&lang=js"
import style0 from "./examModel.vue?vue&type=style&index=0&id=6d7c0824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7c0824",
  null
  
)

export default component.exports